import { useState } from "react";

const faqs = [
  {
    question: "Por que minha conta foi bloqueada?",
    answer:
      "O bloqueio judicial de conta ocorre quando um juiz autoriza a penhora de valores para satisfazer uma dívida reconhecida em processo judicial. Isso pode decorrer de execução fiscal, ação trabalhista, cumprimento de sentença ou outras cobranças judiciais. O sistema BacenJud (Sisbajud) permite que o juiz bloqueie valores diretamente nas contas bancárias do devedor de forma eletrônica.",
  },
  {
    question: "Salário pode ser bloqueado judicialmente?",
    answer:
      "A legislação brasileira, em regra, protege valores de natureza salarial de penhora. O Código de Processo Civil prevê a impenhorabilidade de salários, vencimentos e proventos. No entanto, existem exceções e casos em que o bloqueio ocorre por engano ou quando os valores já foram misturados com outros na conta. É preciso análise concreta do caso para verificar o que é aplicável.",
  },
  {
    question: "Aposentadoria e pensão podem ser bloqueadas?",
    answer:
      "Benefícios previdenciários como aposentadoria, pensão por morte e auxílio-doença têm proteção legal semelhante à do salário. Geralmente são impenhoráveis, especialmente quando representam a única fonte de subsistência. Contudo, em casos de dívidas alimentares e em algumas situações específicas, pode haver exceções. Cada caso requer avaliação técnica.",
  },
  {
    question: "Preciso agir rápido após o bloqueio?",
    answer:
      "Sim. Os prazos processuais são rigorosos e o silêncio pode ser interpretado como concordância com a cobrança. Além disso, quanto mais rápido for o pedido de desbloqueio, menores são os prejuízos causados à sua vida financeira ou ao funcionamento da empresa. Uma análise imediata é altamente recomendada.",
  },
  {
    question: "Posso pedir o desbloqueio sem advogado?",
    answer:
      "Tecnicamente é possível em alguns casos, mas não é recomendável. O pedido de desbloqueio envolve argumentação jurídica técnica — identificação de impenhorabilidade, análise de excesso, vícios no processo — que requer conhecimento específico. Um pedido mal fundamentado pode ser indeferido, dificultando nova tentativa.",
  },
  {
    question: "O bloqueio pode vir de uma execução fiscal?",
    answer:
      "Sim, é uma das causas mais comuns. Municípios, Estados e a União utilizam a execução fiscal para cobrar tributos não pagos, como IPTU, ISS, ICMS, INSS, e outros. Nesses casos, além do pedido de desbloqueio, pode ser necessário questionar a legalidade do próprio crédito tributário — identificando prescrição, vícios na CDA ou cobrança indevida.",
  },
  {
    question: "Quanto tempo demora o processo de desbloqueio?",
    answer:
      "Não há um prazo fixo. Depende do tipo de processo, do fundamento jurídico utilizado, da carga do juízo e da complexidade do caso. Algumas decisões são proferidas em dias, outras levam semanas ou meses. O que impacta diretamente é a qualidade técnica da argumentação apresentada e a urgência demonstrada.",
  },
  {
    question: "O que acontece se eu não fizer nada?",
    answer:
      "Os valores bloqueados podem ser transferidos definitivamente para o credor após determinado prazo. Além disso, novos bloqueios podem ser realizados em outras contas ou bens. Em execuções fiscais, a inércia pode resultar em penhora de imóveis e outros bens. A omissão raramente resolve o problema — na maioria dos casos, o agrava.",
  },
];

export default function Testimonials() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3">
            Dúvidas frequentes
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Perguntas sobre bloqueio judicial
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Respostas objetivas para as principais dúvidas de quem teve valores bloqueados.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors duration-150"
              >
                <span className="text-gray-800 font-medium text-sm leading-snug">
                  {faq.question}
                </span>
                <div className="w-7 h-7 flex items-center justify-center shrink-0">
                  <i
                    className={`${
                      openIndex === index ? "ri-subtract-line" : "ri-add-line"
                    } text-amber-500 text-lg transition-transform duration-200`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 border-t border-gray-100">
                  <p className="text-gray-600 text-sm leading-relaxed pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
